<!-- Main Area Starts -->
  <div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 bg-none no-shadow table-responsive">
    <table class="table tbl-card">
      <tr class="row m-0">
        <td class="col col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 card border-0">

          <img src="assets/images/close.png" class="btn-close" alt="">

          <div class="d-flex mb-5">
            <div class="data">
              <h6 class="font-weight-normal label-darkblue">
                Manage Supplier Data
              </h6>

              <p class="m-0 desc text-500">
                ISA
              </p>
            </div>

            <div class="more">
              <img src="assets/images/more.png" alt="">
            </div>
          </div>

          <div class="panel">
            <div class="float-right">
              <p class="mb-1 text-center">
                <a [routerLink]="['/company']" ><img src="assets/images/supplier-md.png" class="img-panel"></a>
              </p>
              <span class="text-center"> PANEL </span>
            </div>
          </div>
        </td>

        <td class="col col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 card border-0">
          <img src="assets/images/close.png" class="btn-close" alt="">

          <div class="d-flex mb-5">
            <div class="data">
              <h6 class="font-weight-normal label-darkblue">
                Manage Commodity Data
              </h6>

              <p class="m-0 desc text-500">
                ISA
              </p>
            </div>

            <div class="more">
              <img src="assets/images/more.png" alt="">
            </div>
          </div>

          <div class="panel">
            <div class="float-right">
              <p class="mb-1 text-center">
                <a [routerLink]="['/commodity']" ><img src="assets/images/commodity-md.png" class="img-panel"></a>
              </p>
              <span class="text-center"> PANEL </span>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </section>

  <section class="col-12 col-sm12- col-md-12 col-lg-12 col-xl-12 bg-none no-shadow">
    <button type="button" class="btn btn-custom btn-custom-sm btn-blue d-flex">
      <img src="assets/images/add-md.png" alt="" class="img-btn">
      Add Group
    </button>
  </section>
</div>
<!-- Main Area Ends -->